import { Dispatch, SetStateAction } from 'react';
import { cn } from '../../../utils/common-utils.ts';

export interface IQuestionInfoData {
  title: string;
  value: string | number | null | undefined;
}
interface IProps {
  isMath: boolean;
  data?: IQuestionInfoData[];
  isReportAvailable: boolean;
  questionId?: number;
  setIsCalc: Dispatch<SetStateAction<boolean>>;
  className?: HTMLDivElement['className'];
}

const QuestionToolbar = ({
  data,
  className = '',
}: IProps) => {
  if (!data?.length) return null;

  return (
    <section className={cn('flex items-center justify-between p-2', className)}>
      <div className={'flex-center text-center text-sm'}>
        {data?.map((item) => (
          <div className={'mx-1'} key={item.title}>
            <span className={'mr-1 font-semibold'}>{item.title}</span>
            <span>{item.value}</span>
          </div>
        ))}
      </div>
    </section>
  );
};
export default QuestionToolbar;
